const instruction = {
  namespaced: true,
  state: {
    wxConfigObj: {
      a: 1
    }
  },
  getters: {},
  mutations: {},
  actions: {
    async queryinstructionDetail({ rootState }, params = {}) {
      const data = await rootState.http("/tutorial/findTutorial", params);
      return data;
    }
  }
};

export default instruction;



// WEBPACK FOOTER //
// ./src/store/modules/instruction.js